import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

import { FormControl, Grid, MenuItem, Select } from "@mui/material"

import { useDispatch } from "react-redux"

import { useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import useStyles from "./Styles/useStylesSeeDetails"
import {
  getSubscriberStatus,
  getSuscriberRefID,
} from "../../../../../redux/actions/Suscriber"
import ModalConfirmChange from "../../../../../components/Modals/Organizations/User/ModalConfirmChange/ModalConfirmChange"
import { updateSubscriberCorpEntities } from "../../../../../app/services/Suscriber/updateSubscriberCorpEntities"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../../../redux/actions/app"

export default function StepperSeeDetailsSuscriber({
  item,
  setstateDetailsSuscriber,
  setLoading,
}) {
  const dispatch = useDispatch()
  const classes = useStyles()

  const [suscriber, setsuscriber] = useState(null)
  const [statesSuscriber, setstatesSuscriber] = useState([])
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [selectedStatusId, setSelectedStatusId] = React.useState(null)

  useEffect(async () => {
    if (!suscriber) {
      setLoading(true)
      const getsuscriber = await handleGetSuscriber()
      if (getsuscriber !== "Error") {
        await handleGetNameStatusCode(getsuscriber.subscriber_status_id)
      }
      setLoading(false)
    }
  }, [])

  // request get suscriber and set in state or error message
  const handleGetSuscriber = async () => {
    const params = {
      clicod: item.subscriber_ref_id,
    }
    const getsuscriber = await dispatch(getSuscriberRefID(params))
    setsuscriber(getsuscriber)
    return getsuscriber
  }

  const handleOpenModalChangeStatus = (newStatusId) => {
    setSelectedStatusId(newStatusId)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedStatusId(null)
  }

  // return name of status suscriber with codeState
  const getName = (codeSuscriber) => {
    const state = statesSuscriber.filter(
      (x) => x.subscriber_status_id === codeSuscriber,
    )
    return state.length > 0 ? state[0].subscriber_status_desc : null
  }

  // request get and set status list or error message
  const handleGetNameStatusCode = async () => {
    const status = await dispatch(getSubscriberStatus())
    setstatesSuscriber(status)
  }

  // return date string of visual
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }

  const handleConfirmChangeStatus = async () => {
    handleCloseModal()
    setLoading(true)
    const subscriberId = suscriber.subscriber_id
    try {
      const requestBody = {
        clicod: suscriber.subscriber_ref_id ?? "",
        subscriber_name: suscriber.subscriber_name ?? "",
        organization_cuit: suscriber.organizationCuit ?? "",
        organization_legal_name: suscriber.organization_legal_name ?? "",
        subscriber_max_user_count: suscriber.subscriber_max_user_count ?? "",
        subscriber_status_id: selectedStatusId,
      }


      await updateSubscriberCorpEntities(subscriberId, requestBody)

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Estado actualizado correctamente."))

      await handleGetSuscriber()
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar("Ocurrió un error al actualizar el estado."),
      )
    } finally {
      setLoading(false)
    }
  }

  const Suscriber = () => {
    return (
      suscriber && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}> Razón social:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_name || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                {" "}
                Numero de suscriptor:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_ref_id || "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Máximo de usuarios:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_max_user_count}{" "}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Fecha de creación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(suscriber.creation_date)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Creado por:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.creation_user}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Última modificación:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {formatDate(suscriber.modification_date)
                  ? formatDate(suscriber.modification_date)
                  : "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Modificado por:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.modification_user || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>ID de suscriptor:</Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {suscriber.subscriber_id || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            className={classes.container}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Estado:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <FormControl style={{ minWidth: 160 }} className={classes.value}>
                <Select
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={suscriber.subscriber_status_id}
                  onChange={(e) => handleOpenModalChangeStatus(e.target.value)}
                  renderValue={(selectedId) => {
                    if (!selectedId) {
                      return <span style={{ color: "#aaa" }}>- -</span>
                    }
                    return getName(selectedId)
                  }}
                >
                  {statesSuscriber.map((state) => (
                    <MenuItem
                      key={state.subscriber_status_id}
                      value={state.subscriber_status_id}
                    >
                      {state.subscriber_status_desc}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {isModalOpen && (
              <ModalConfirmChange
                title="Confirmar cambio de estado"
                message={`¿Estás seguro de cambiar el estado del suscriptor?`}
                open={isModalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirmChangeStatus}
              />
            )}
          </Grid>
        </>
      )
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: "100%",
            display: "flex",
            padding: "8px 0px 8px 0px",
            justifyContent: "space-between",
            boxShadow: "0px 1px 1px #EAEAEA",
            color: "#8C8C8C",
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información del suscriptor
          </Typography>
          <CloseIcon
            style={{
              cursor: "pointer",
              paddingRight: 10,
              fontSize: "1.5rem",
            }}
            onClick={() => {
              setstateDetailsSuscriber(false)
            }}
          />
        </div>
        <div className={classes.mainBox}>
          <Suscriber item={item} />
        </div>

        <ButtonClose setstateDetailsSuscriber={setstateDetailsSuscriber} />
      </Box>
    </>
  )
}

function ButtonClose({ setstateDetailsSuscriber }) {
  const classes = useStyles()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          "&:hover": {
            bgcolor: "#1BF57F",
          },
        }}
      >
        <Typography
          onClick={() => {
            setstateDetailsSuscriber(false)
          }}
          className={classes.closeButtonTypography}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
